<template>
  <div class="learning-tabs-container mb-4">
    <div class="learning-tabs">
      <div
        class="learning-tab"
        :class="{ active: localActiveTab === 'structured_learning', disabled: isLoading }"
        @click="onTabClick('structured_learning')"
        :aria-disabled="isLoading"
        :tabindex="isLoading ? -1 : 0"
      >
        <span class="tab-text">Structured Learning</span>
      </div>
      <div
        class="learning-tab"
        :class="{ active: localActiveTab === 'social_learning', disabled: isLoading }"
        @click="onTabClick('social_learning')"
        :aria-disabled="isLoading"
        :tabindex="isLoading ? -1 : 0"
      >
        <span class="tab-text">Social Learning</span>
      </div>
      <div
        class="learning-tab"
        :class="{ active: localActiveTab === 'experiential_learning', disabled: isLoading }"
        @click="onTabClick('experiential_learning')"
        :aria-disabled="isLoading"
        :tabindex="isLoading ? -1 : 0"
      >
        <span class="tab-text">Experiential Learning</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    activeTab: {
      type: String,
      default: "structured_learning",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localActiveTab: this.activeTab,
    };
  },
  watch: {
    activeTab(newVal) {
      this.localActiveTab = newVal;
    },
  },
  methods: {
    setActiveTab(tab) {
      if (this.localActiveTab !== tab) {
        this.localActiveTab = tab;
        this.$emit("tab-changed", tab);
      }
    },
    onTabClick(tab) {
      if (this.isLoading) return;
      this.setActiveTab(tab);
    },
  },
};
</script>

<style>
.learning-tabs-container {
  display: flex;
  justify-content: start;
  margin: 2rem 0;
}

.learning-tabs {
  display: flex;
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
}

.learning-tab {
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 12px;
  color: #6b7280;
  background-color: transparent;
  min-width: 140px;
  text-align: center;
}

.learning-tab:hover {
  background-color: #e5e7eb;
  color: #374151;
}

.learning-tab.active {
  background-color: #dc2626;
  color: white;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2);
}

.learning-tab.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.learning-tab .tab-text {
  font-weight: inherit;
}
</style>
